module.exports = "/_next/static/images/3a5e875c48f329b36fe1abdb34626a96-man-with-cellphone-xs@3x.jpg";